import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Hero } from './components/Hero';
import { FeaturedVehicles } from './components/FeaturedVehicles';
import { Services } from './components/Services';
import { Footer } from './components/Footer';
import { AdminDashboard } from './pages/AdminDashboard';
import { AdminVehicles } from './pages/AdminVehicles';
export function App() {
  return <Routes data-id="element-0">
      {/* Public Site */}
      <Route path="/" element={<div className="w-full min-h-screen bg-[var(--color-black-deep)]" data-id="element-2">
            <Hero data-id="element-3" />
            <FeaturedVehicles data-id="element-4" />
            <Services data-id="element-5" />
            <Footer data-id="element-6" />
          </div>} data-id="element-1" />

      {/* Admin Routes */}
      <Route path="/admin" element={<AdminDashboard data-id="element-8" />} data-id="element-7" />
      <Route path="/admin/vehicles" element={<AdminVehicles data-id="element-10" />} data-id="element-9" />
    </Routes>;
}